import { logger } from '@/utils/logger/logger';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useMemo } from 'react';

interface DatadogDurationVitalStopperProps {
  condition?: boolean;
  vitalName: string | string[];
  debugPrint?: boolean;
  disableRafBehaviour?: boolean;
}
export function DatadogDurationVitalStopper({
  condition = true,
  vitalName,
  debugPrint = false,
  disableRafBehaviour = false,
}: DatadogDurationVitalStopperProps) {
  const names = useMemo(
    () => (Array.isArray(vitalName) ? vitalName : [vitalName]),
    [vitalName]
  );
  useEffect(() => {
    if (condition) {
      if (!disableRafBehaviour) {
        const raf = requestAnimationFrame(() => {
          names.forEach((vn) => datadogRum.stopDurationVital(vn));
          if (debugPrint) {
            logger.info(`[DATADOG_DURATION][STOP] ${names.join(', ')}`);
          }
        });
        return () => cancelAnimationFrame(raf);
      }
      names.forEach((vn) => datadogRum.stopDurationVital(vn));
      if (debugPrint) {
        logger.info(`[DATADOG_DURATION][STOP] ${names.join(', ')}`);
      }
    }
  }, [condition, debugPrint, names, disableRafBehaviour]);
  return null;
}
